<template>
  <section>
    <div
      style="display: flex; width: 100%; margin-top: 20px; margin-bottom: -20px"
    >
      <div class="demo-input-suffix" style="width: 507px">
        学届
        <el-select
          v-model="value1"
          placeholder="全部"
          @change="onOptionsyear"
          style="width: 200px; margin: 3px 30px 5px 7px"
          id="inputselect"
        >
          <el-option
            v-for="item in AddOptionsyear3"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="demo-input-suffix" style="width: 507px">
        年级
        <el-select
          v-model="value2"
          placeholder="全部"
          @change="onOptionsyear2Select"
          style="width: 200px; margin: 3px 30px 5px 15px"
          id="inputselect"
        >
          <el-option
            v-for="item in optionsyear2"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <toolbar
        style="width: 100%"
        :buttonList="buttonList"
        @callFunction="callFunction"
      ></toolbar>
    </div>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->

    <!--列表-->
    <!-- <div style="display: flex; width: 100%; align-items: center">
      <el-select
        style="width: 200px; margin: 3px 30px 5px 7px"
        v-model="value1"
        placeholder="请选择学界"
        @change="onOptionsyear"
      >
        <el-option
          v-for="item in AddOptionsyear3"
          :key="item.Id"
          :label="item.Name"
          :value="item.Id"
        >
        </el-option>
      </el-select>
      <div>
        <el-button type="primary" @click="openStatus">开启</el-button>
        <el-button type="danger" @click="closeStatus">关闭</el-button>
        
      </div>
    </div> -->
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <!-- <el-table-column type="selection" width="55"> </el-table-column> -->

      <el-table-column
        prop="StudyYearName"
        label="学届"
        width
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="GradeName"
        label="年级"
        width
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="CategoryName"
        label="类型"
        width
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="周期名称"
        width
        sortable
        align="center"
      ></el-table-column>
      <el-table-column label="状态" width sortable align="center">
        <template slot-scope="scope">
          <el-tag
            :type="
              scope.row.Status == 1
                ? 'success'
                : scope.row.Status == 0
                ? 'info'
                : scope.row.Status == 2
                ? 'danger'
                : scope.row.Status == 3
                ? 'warning'
                : ''
            "
          >
            {{ scope.row.StatusName }}</el-tag
          >
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量开启/关闭</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item label="所属学届" prop="value1">
          <el-select
            v-model="editForm.StudyYearName"
            placeholder="请选择所属学届"
          >
            <el-option
              v-for="item in AddOptionsyear3"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属年级" prop="value2">
          <el-select
            v-model="editForm.GradeName"
            placeholder="请选择所属周期名称"
          >
            <el-option
              v-for="item in AddOptionsyear"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属类型" prop="value3">
          <el-select
            v-model="editForm.CategoryName"
            placeholder="请选择所属类型"
          >
            <el-option
              v-for="item in AddOptionsyear2"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期名称" prop="name">
          <el-input
            v-model="editForm.Name"
            type="text"
            placeholder="请输入周期名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="editForm.Status">
            <el-radio :label="0">关闭</el-radio>
            <el-radio :label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="orderSort">
          <el-input v-model="editForm.OrderSort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="所属学届" prop="value1">
          <el-select v-model="addForm.value1" placeholder="请选择所属学届">
            <el-option
              v-for="item in AddOptionsyear3"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属年级" prop="value2">
          <el-select v-model="addForm.value2" placeholder="请选择所属周期名称">
            <el-option
              v-for="item in AddOptionsyear"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属类型" prop="value3">
          <el-select v-model="addForm.value3" placeholder="请选择所属类型">
            <el-option
              v-for="item in AddOptionsyear2"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="周期名称" prop="name">
          <el-input
            v-model="addForm.name"
            type="text"
            placeholder="请输入周期名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="addForm.status">
            <el-radio label="0">关闭</el-radio>
            <el-radio label="1">开启</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="排序" prop="orderSort">
          <el-input v-model="addForm.orderSort"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 重置密码 -->
    <el-dialog title="操作" :visible.sync="passwordDialogVisible" width="30%">
      <div>
        <el-input
          v-model="isPawassrd"
          type="number"
          placeholder="请输入密码"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="btnPassword">确 定</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import store from "../../store";
import util from "../../../util/date";
import {
  GetCycleInfoByPage,
  GetCateSelect,
  AddCycle,
  GetYearsInfo,
  GetGradeInfo,
  GetClassInfo,
  UpdateCycle,
  DeleteCycle,
  OpenCycle,
  CloseCycle,
  AddRecordInfo,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { isString } from "../../../util/validate";

export default {
  components: { Toolbar, quillEditor },
  data() {
    return {
      passwordDialogVisible: false,
      value1: "",
      value2: "",
      value3: "",
      isPawassrd: "",
      studentNum: "",
      studentName: "",
      optionsyear: [],
      optionsyear2: [],
      optionsyear3: [],
      AddOptionsyear: [],
      AddOptionsyear2: [],
      AddOptionsyear3: [],
      headers: {
        Authorization: "",
      },
      contentstatus: false,
      content: ``,
      editorOption: {},
      imageUrl: "",
      catelist: [],
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      //statusList: [{LinkUrl: '激活', value: true}, {LinkUrl: '禁用', value: false}],
      total: 0,
      page: 1,
      pagesize: 13,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CateId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        QuestionTitle: [
          { required: true, message: "请输入问题", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {},
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入学生名称", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        studentCode: [
          { required: true, message: "请输入所属学号", trigger: "blur" },
        ],
        value1: [
          { required: true, message: "请输入所属学届", trigger: "blur" },
        ],
        value2: [
          { required: true, message: "请输入所属年级", trigger: "blur" },
        ],
        value3: [
          { required: true, message: "请输入所属班级", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        value1: "",
        value2: "",
        value3: "",
        status: "0",
        orderSort: "",
      },
      passwordRow: 0,
    };
  },
  modules: {
    toolbar: {
      container: [
        //配置项，全部配置如上
        ["bold", "italic", "underline"],
        [{ align: [] }],
        ["image"],
      ],
      handlers: {
        image: function (value) {
          if (value) {
            document.querySelector(".avatar-uploader input").click();
          } else {
            this.quill.format("image", false);
          }
        },
      },
    },
  },
  created() {
    this.GetCateSelect();
  },
  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },
  methods: {
    // 开启周期
    openStatus() {
      if (this.sels.length == 0) {
        this.$message({
          message: "请选择对应的选项",
          type: "error",
        });
      } else {
        OpenCycle({ ids: this.sels }).then((res) => {
          if (res.data.success) {
            this.AddRecordInfo("修改", "基础信息管理-周期管理-开启周期");
            this.$message({
              message: "开启成功",
              type: "success",
            });
            this.getModules();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },
    // 关闭周期
    closeStatus() {
      if (this.sels.length == 0) {
        this.$message({
          message: "请选择对应的选项",
          type: "error",
        });
      } else {
        CloseCycle({ ids: this.sels }).then((res) => {
          if (res.data.success) {
            this.AddRecordInfo("修改", "基础信息管理-周期管理-关闭周期");
            this.$message({
              message: "关闭成功",
              type: "success",
            });
            this.getModules();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      }
    },
    // 获取周期分类select
    GetCateSelect() {
      GetCateSelect().then((res) => {
        console.log(res);
        this.optionsyear = res.data.response;
      });
      this.GetYearsInfo();
    },
    // 重置密码
    setResetPawassed(row) {
      this.passwordRow = row.Id;
      console.log(row.Id);
      this.passwordDialogVisible = true;
    },
    btnPassword() {
      if (this.isPawassrd != "") {
        let params = {
          id: this.passwordRow,
          password: this.isPawassrd,
        };
        RestPassword(params).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "重置成功",
              type: "success",
            });
            this.passwordDialogVisible = false;
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请输入密码",
          type: "error",
        });
      }
    },
    onOptionsyear() {
      GetGradeInfo().then((res) => {
        // if (res.data.response.length > 0) {
        //   this.value2 = res.data.response[0].Id;
        //   //   this.onOptionsyear();
        // }
        this.optionsyear2 = res.data.response;
        this.getModules();
      });
    },
    onOptionsyear2() {
      if (this.value1 != "" && this.value2 != "") {
        GetClassInfo({
          studyYearId: this.value1,
          gradeId: this.value2,
        }).then((res) => {
          this.optionsyear3 = res.data.response;
          this.getModules();
        });
      }
    },
    ///上面选择年级
    onOptionsyear2Select() {
      if (this.value1 != "" && this.value2 != "") {
        this.getModules();
      }
    },
    onOptionsyear3() {
      this.getModules();
    },
    //获取班级列表
    GetYearsInfo() {
      GetYearsInfo().then((res) => {
        this.AddOptionsyear3 = res.data.response;
      });
    },
    radiochange(val) {
      console.log(val);
      // if (val == 1) {
      //   this.contentstatus=false;
      // } else {
      //     this.contentstatus=true;
      // }
    },
    onEditorReady(editor) {}, // 准备编辑器
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    saveHtml(event) {
      alert(this.content);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.response;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    async AddRecordInfo(action, description) {
      var user = JSON.parse(
        window.localStorage.user ? window.localStorage.user : null
      );
      let res = await AddRecordInfo({
        userName: user.uRealName + "-" + user.uLoginName,
        action: action,
        description: description,
      });
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.CreateTime),
            "yyyy-MM-dd hh:MM:ss"
          );
    },
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getModules();
    },
    // changeStatus(val){
    //     this.statusvalue=val;
    //     this.getModules();
    // },
    //获取分类
    getCateInfo() {
      let para = {};
      GetCateListByPage(para).then((res) => {
        this.catelist = res.data.response;
      });
    },
    //获取用户列表
    getModules() {
      let para = {
        StudyYearId: this.value1 == "" ? 0 : this.value1,
        GradeId: this.value2 == "" ? 0 : this.value2,
        Name: this.filters.name,
        PageIndex: this.page,
        PageSize: this.pagesize,
      };
      this.listLoading = true;

      //NProgress.start();
      GetCycleInfoByPage(para).then((res) => {
        this.listLoading = false;
        this.users = res.data.response.data;
        this.total = res.data.response.dataCount;
        //NProgress.done();
      });
    },
    //删除
    handleDel() {
      let row = this.currentRow;
      if (this.sels.length == 0) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          console.log(this.sels);
          DeleteCycle({ ids: this.sels }).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit() {
      let row = this.currentRow;

      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      GetYearsInfo().then((res) => {
        this.AddOptionsyear3 = res.data.response;
      });
      GetCateSelect().then((res) => {
        this.AddOptionsyear2 = res.data.response;
      });
      GetGradeInfo().then((res) => {
        this.AddOptionsyear = res.data.response;
      });
      console.log(this.editForm);
      // this.imageUrl = this.editForm.QuestionImg;
      // if (this.editForm.QuestionType == 1) {
      //   this.contentstatus=false;
      // } else {
      //     this.contentstatus=true;
      // }
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.GetYearsInfo();
      GetCateSelect().then((res) => {
        this.AddOptionsyear2 = res.data.response;
      });
      GetGradeInfo().then((res) => {
        this.AddOptionsyear = res.data.response;
      });
    },
    // 年级下拉事件
    getUserScroll() {
      if (this.addForm.value1 != "" && this.addForm.value2 != "") {
        GetClassInfo({
          studyYearId: this.addForm.value1,
          gradeId: this.addForm.value2,
        }).then((res) => {
          this.AddOptionsyear3 = res.data.response;
        });
      }
    },
    editUserScroll() {
      if (this.editForm.StudyYearName != "" && this.editForm.GradeName != "") {
        console.log(this.editForm.StudyYearId);
        GetClassInfo({
          studyYearId: this.isString(this.editForm.StudyYearName)
            ? this.editForm.StudyYearId
            : this.editForm.StudyYearName,
          gradeId: this.editForm.GradeName,
        }).then((res) => {
          this.AddOptionsyear3 = res.data.response;
        });
      }
    },
    isString(str) {
      return str instanceof String || typeof str == "string";
    },
    //编辑
    editSubmit: function () {
      this.headers.Authorization = "Bearer " + store.state.token;
      this.$confirm("确定编辑该内容?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = Object.assign({}, this.editForm);
          console.log(para);
          let params = {
            id: this.editForm.Id,
            categoryId: para.CategoryId,
            studyYearId: para.StudyYearId,
            gradeId: para.GradeId,
            name: para.Name,
            status: para.Status,
            orderSort: para.OrderSort,
          };
          UpdateCycle(params).then((res) => {
            console.log(res, "-");
            if (res.data.success) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.editFormVisible = false;
              this.getModules();
              console.log(this.editFormVisible);
            }
          });
        })
        .catch(() => {});
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let params = {
              categoryId: _this.addForm.value3,
              studyYearId: _this.addForm.value1,
              gradeId: _this.addForm.value2,
              name: _this.addForm.name,
              status: _this.addForm.status,
              orderSort: _this.addForm.orderSort,
            };
            AddCycle(params).then((res) => {
              if (res.data.success) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.addFormVisible = false;
                this.getModules();
              }
            });
          });
        }
      });
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
    selsChange: function (sels) {
      console.log(sels);
      let ids = [];
      sels.map((item) => {
        ids.push(item.Id);
      });
      console.log(ids);
      this.sels = ids;
    },
  },
  mounted() {
    this.getModules();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.headers.Authorization = "Bearer " + store.state.token;
  },
};
</script>

<style scoped>
.btnQuery {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-input {
  width: 150px;
  margin: 10px;
}
.el-select {
  margin: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}
.avatar {
  width: 320px;
  height: 180px;
  display: block;
}
</style>
